import React from 'react';
import HelpContent from './../HelpContent';

const EscenarioCN2Help = () => (
  <HelpContent>
    <h1>
        Escenario Carbono Neutralidad 2 (CN2)
    </h1>
    <p> Este escenario proyecta las emisiones a nivel nacional considerando la implementación de las principales medidas de mitigación propuestas en el NDC del año 2025 
      (retiro de centrales a carbón, electromovididad, introducción de hidroógeno verde, electrificación de usos finales en el sector residencial, etc.).
    </p>
      
    <p> Los resultados de este escenario también cumplen con la meta de carbono neutralidad al 2050. Este escenario agrega transiciones más agresivas en medidas, 
      tecnologías o usos particulares, por tanto, se alcanza a un nivel de emisiones más bajo que el escenario CN1.

    </p>

  
  </HelpContent>
);

export default EscenarioCN2Help;
